import { Controller } from '@hotwired/stimulus'
import { MAX_RESOLUTION_NAME_LENGTH } from './constants'
import { PLEASE_ENTER_RESOLUTION_NAME, RESOLUTION_NAME_TOO_LONG, trans } from '../../translator'

export default class extends Controller {
  static targets = ['modal', 'form', 'error']

  connect () {
    $(this.formTarget).form({
      fields: {
        resolution_name: {
          rules: [
            {
              type: 'empty',
              prompt: trans(PLEASE_ENTER_RESOLUTION_NAME, {}, 'resolutions')
            },
            {
              type: `maxLength[${MAX_RESOLUTION_NAME_LENGTH}]`,
              prompt: trans(RESOLUTION_NAME_TOO_LONG, { '%parameter%': MAX_RESOLUTION_NAME_LENGTH }, 'resolutions')
            }
          ]
        }
      },
      inline: true,
      keyboardShortcuts: false
    })

    this.formTarget.addEventListener('submit', (e) => e.preventDefault())
  }

  openModal (event) {
    event.preventDefault()
    this.hideError()
    $(this.formTarget).form('clear')

    const modal = $(this.modalTarget)
    modal.modal('show')

    modal.one('shown.bs.modal', () => {
      const input = this.formTarget.querySelector('input')
      if (input) input.focus()
    })

    this.formAction = event.currentTarget.dataset.formAction
    this.resolutionGroupResolutionsContainer = event.currentTarget.closest('.resolution-group').querySelector('.resolutions')
  }

  async submitForm (event) {
    event.preventDefault()
    this.hideError()

    if (!$(this.formTarget).form('is valid')) {
      $(this.formTarget).form('validate form')
      return
    }

    const submitButton = event.currentTarget
    submitButton.disabled = true
    submitButton.querySelector('i').classList.toggle('d-none')

    const name = this.formTarget.querySelector('#resolution_name').value

    try {
      const response = await fetch(this.formAction, {
        method: 'POST',
        body: JSON.stringify({ name }),
        headers: {
          'Content-Type': 'application/json'
        }
      })

      if (response.ok) {
        $(this.modalTarget).modal('hide')

        const html = await response.text()
        this.resolutionGroupResolutionsContainer.insertAdjacentHTML('beforeend', html)
        this.formTarget.reset()
      } else if (response.status === 400) {
        const data = await response.json()
        $(this.formTarget).form('add prompt', 'resolution_name', data.message)
      } else {
        this.showError()
      }
    } catch (error) {
      this.showError()
    } finally {
      submitButton.disabled = false
      submitButton.querySelector('i').classList.toggle('d-none')
    }
  }

  showError () {
    this.errorTarget.classList.remove('d-none')
  }

  hideError () {
    this.errorTarget.classList.add('d-none')
  }
}
